import React from 'react';
import { RadioButtonSingle } from 'components/RadioButtons/RadioButtons';
import { ItineraryTypes } from '../types';

export type TFilterOption = 'FULL_OVERVIEW' | 'STAYS' | 'TRANSFERS' | 'GROUND_SERVICES' | 'EXPERIENCES';

export interface IItineraryOverviewFilterProps {
  datedItems: ItineraryTypes['ItineraryItem'][];
  undatedItems: ItineraryTypes['ItineraryItem'][];
  selectedFilter: TFilterOption;
  onFilterChange: (filter: TFilterOption) => void;
}

export const ItineraryOverviewFilter = ({
  datedItems,
  undatedItems,
  selectedFilter,
  onFilterChange,
}: IItineraryOverviewFilterProps) => {
  // Count items by type
  const allItems = [...datedItems, ...undatedItems];

  const counts = {
    stays: allItems.filter(item => item.itemType === 'accommodation' || item.itemType === 'hotelMarker').length,
    transfers: allItems.filter(item => item.itemType === 'transfer').length,
    groundServices: allItems.filter(item => item.itemType === 'groundService').length,
    experiences: allItems.filter(item => item.itemType === 'bespoke').length,
  };

  // Build options array based on counts
  const options = [{ label: 'FULL OVERVIEW', value: 'FULL_OVERVIEW' }];

  if (counts.stays > 0) {
    options.push({ label: 'STAYS', value: 'STAYS' });
  }

  if (counts.transfers > 0) {
    options.push({ label: 'TRANSFERS', value: 'TRANSFERS' });
  }

  if (counts.groundServices > 0) {
    options.push({ label: 'GROUND SERVICES', value: 'GROUND_SERVICES' });
  }

  if (counts.experiences > 0) {
    options.push({ label: 'EXPERIENCES', value: 'EXPERIENCES' });
  }

  return (
    <div className="bg-gray-3 p-20px pb-15px">
      <div className="flex flex-row flex-wrap items-center gap-20px">
        {options.map(option => (
          <div key={option.value} className="flex items-center gap-8px">
            <RadioButtonSingle
              id={`filter-${option.value}`}
              onSelect={() => onFilterChange(option.value as TFilterOption)}
              isSelected={selectedFilter === option.value}
              value={option.value}
              containerClass="-mt-[14px] w-[20px] -mr-[12px]"
            />
            <span
              onClick={() => onFilterChange(option.value as TFilterOption)}
              className="font-hurmegeometric-sans text-14px text-flint uppercase cursor-pointer"
            >
              {option.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
